"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTableRenders = _interopRequireDefault(require("cccisd-table-renders"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Boilerplate = window.cccisd.boilerplate;
var linkRender = function linkRender(_ref) {
  var value = _ref.value,
    row = _ref.row;
  return typeof value === 'string' ? /*#__PURE__*/_react["default"].createElement("a", {
    href: Boilerplate.url(value),
    style: {
      whiteSpace: 'nowrap'
    }
  }, _cccisdTableRenders["default"].html.Shorten({
    maxLength: 40,
    tail: 10
  })({
    value: value
  })) : value;
};
var resourceLinkRender = function resourceLinkRender(_ref2) {
  var value = _ref2.value,
    row = _ref2.row;
  return row['resource.resourceId'] ? /*#__PURE__*/_react["default"].createElement("a", {
    target: "log_resource",
    href: Boilerplate.url(row.url) + '/' + row['resource.resourceId']
  }, _cccisdTableRenders["default"].html.Shorten({
    maxLength: 40,
    tail: 10
  })({
    value: value
  })) : value;
};
var durationRender = function durationRender(_ref3) {
  var value = _ref3.value,
    row = _ref3.row;
  var duration = value;
  if (duration === 0) {
    return '< 1 second';
  }
  if (duration < 60) {
    return duration + ' second' + (duration === 1 ? '' : 's');
  }
  duration /= 60.0;
  if (duration < 60) {
    duration = duration.toFixed(1);
    return duration + ' minutes';
  }
  duration /= 60;
  if (duration < 60) {
    duration = duration.toFixed(1);
    return duration + ' hours';
  }
  duration /= 24;
  duration = duration.toFixed(1);
  return duration + ' days';
};
var permissionsChangeRender = function permissionsChangeRender(_ref4) {
  var value = _ref4.value,
    row = _ref4.row;
  var ret = [];
  Object.keys(row).forEach(function (prop, index) {
    if (prop.substring(0, 9) === 'metadata.') {
      ret.push( /*#__PURE__*/_react["default"].createElement("div", {
        key: 'perm_' + prop
      }, row[prop] ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-success"
      }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)) : /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-danger"
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), "\xA0\xA0", prop.substring(9)));
    }
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, ret);
};
var _default = exports["default"] = {
  linkRender: linkRender,
  resourceLinkRender: resourceLinkRender,
  durationRender: durationRender,
  permissionsChangeRender: permissionsChangeRender
};